<template>
  <crud-facecade :url="url"  :columns="columnList" :buttons="buttons" v-wechat-title="title"
                 :addButton="{permission:'permission:create'}" :deleteButton="{permission:'permission:update'}"
                 :updateButton="{permission:'permission:delete'}">
  </crud-facecade>
</template>
<script>
export default {
    name: `CrudTemplate`,
    props: {

    },
    data() {
        return {
            title: `组织架构-院区`,
            url: ``,
            buttons: []
        }
    },
    computed: {
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `select`,
                prop: `parent_id`,
                label: `父级`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this.menus
            }]
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CrudTemplate.vue